import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import getDownloadLogs from '../../../actions/api/activityLog/getDownloadLogs';
import { ACTION_TYPES } from '../../../lib/constants';

/**
 * 引数で指定されたログのダウンロードデータを取得する
 * @param {object[]} logs - ダウンロードデータを取得するログの配列。
 * @returns {object[]} ダウンロードデータを取得したログの配列。対応するログのIDとダウンロードログのデータをプロパティとして持つ。
 */
const useDownloadLogs = logs => {
  const dispatch = useDispatch();
  const apiToken = useSelector(state => state.main.apiToken);
  const [downloadLogs, setDownLoadLogs] = useState([]);

  useEffect(() => {
    const fetchDownloadLogs = async () => {
      const downloadLogsPromises = logs.map(async log => {
        if (log?.action !== ACTION_TYPES.download) {
          return null;
        }
        const downloadLog = await dispatch(
          getDownloadLogs(apiToken, {
            actionLogId: log.id,
            limit: 100,
          }),
        );
        if (downloadLog?.length === 0) {
          return null;
        }
        return { logId: log.id, downloadLog };
      });
      const downloadLogsResults = await Promise.all(downloadLogsPromises);
      const filteredDownloadLogsResults = downloadLogsResults.filter(
        result => result !== null,
      );
      setDownLoadLogs(filteredDownloadLogsResults);
    };

    fetchDownloadLogs();
  }, [apiToken, dispatch, logs]);

  return downloadLogs;
};

export default useDownloadLogs;
